import { render, staticRenderFns } from "./AccountStatusBadge.vue?vue&type=template&id=923cc22e&scoped=true"
import script from "./AccountStatusBadge.vue?vue&type=script&lang=js"
export * from "./AccountStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./AccountStatusBadge.vue?vue&type=style&index=0&id=923cc22e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923cc22e",
  null
  
)

export default component.exports